// Mock data for Foodz Lizts app

export const mockGroceryItems = [
  {
    id: 1,
    name: "Organic Bananas",
    quantity: 1,
    completed: false,
    category: "Produce",
    estimated_price: 3.99
  },
  {
    id: 2,
    name: "Whole Wheat Bread",
    quantity: 1,
    completed: true,
    category: "Bakery",
    estimated_price: 4.49
  },
  {
    id: 3,
    name: "Greek Yogurt",
    quantity: 2,
    completed: false,
    category: "Dairy & Eggs",
    estimated_price: 5.99
  },
  {
    id: 4,
    name: "Free-Range Eggs",
    quantity: 1,
    completed: false,
    category: "Dairy & Eggs",
    estimated_price: 4.79
  },
  {
    id: 5,
    name: "Fresh Spinach",
    quantity: 1,
    completed: true,
    category: "Produce",
    estimated_price: 2.99
  },
  {
    id: 6,
    name: "Olive Oil",
    quantity: 1,
    completed: false,
    category: "Pantry",
    estimated_price: 8.99
  },
  {
    id: 7,
    name: "Chicken Breast",
    quantity: 2,
    completed: false,
    category: "Meat & Seafood",
    estimated_price: 12.99
  },
  {
    id: 8,
    name: "Brown Rice",
    quantity: 1,
    completed: false,
    category: "Pantry",
    estimated_price: 3.49
  },
  {
    id: 9,
    name: "Fresh Strawberries",
    quantity: 1,
    completed: false,
    category: "Produce",
    estimated_price: 4.99
  },
  {
    id: 10,
    name: "Broccoli Crowns",
    quantity: 2,
    completed: false,
    category: "Produce",
    estimated_price: 3.49
  },
  {
    id: 11,
    name: "Orange Juice",
    quantity: 1,
    completed: true,
    category: "Beverages",
    estimated_price: 4.29
  },
  {
    id: 12,
    name: "Frozen Peas",
    quantity: 1,
    completed: false,
    category: "Frozen",
    estimated_price: 2.79
  }
];

// AI-Generated Meal Database with Images
export const aiGeneratedMeals = {
  breakfast: [
    { id: 1, name: "Fluffy Blueberry Pancakes", image: "https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=400&h=300&fit=crop", cookTime: "20 min", difficulty: "Easy", calories: 350 },
    { id: 2, name: "Avocado Toast with Poached Egg", image: "https://images.unsplash.com/photo-1541519227354-08fa5d50c44d?w=400&h=300&fit=crop", cookTime: "15 min", difficulty: "Medium", calories: 280 },
    { id: 3, name: "Greek Yogurt Berry Bowl", image: "https://images.unsplash.com/photo-1511690743698-d9d85f2fbf38?w=400&h=300&fit=crop", cookTime: "5 min", difficulty: "Easy", calories: 220 },
    { id: 4, name: "Chocolate Chip Waffles", image: "https://images.unsplash.com/photo-1562376552-0d160dcb0e64?w=400&h=300&fit=crop", cookTime: "25 min", difficulty: "Medium", calories: 420 },
    { id: 5, name: "Overnight Chia Pudding", image: "https://images.unsplash.com/photo-1511690656952-34342bb7c2f2?w=400&h=300&fit=crop", cookTime: "5 min", difficulty: "Easy", calories: 300 },
    { id: 6, name: "French Toast Sticks", image: "https://images.unsplash.com/photo-1484723091739-30a097e8f929?w=400&h=300&fit=crop", cookTime: "18 min", difficulty: "Easy", calories: 380 },
    { id: 7, name: "Smoothie Acai Bowl", image: "https://images.unsplash.com/photo-1511690743698-d9d85f2fbf38?w=400&h=300&fit=crop", cookTime: "10 min", difficulty: "Easy", calories: 250 },
    { id: 8, name: "Breakfast Burrito", image: "https://images.unsplash.com/photo-1551218808-94e220e084d2?w=400&h=300&fit=crop", cookTime: "22 min", difficulty: "Medium", calories: 450 },
    { id: 9, name: "Banana Foster Oatmeal", image: "https://images.unsplash.com/photo-1571115764595-644a1f56a55c?w=400&h=300&fit=crop", cookTime: "12 min", difficulty: "Easy", calories: 320 },
    { id: 10, name: "Everything Bagel with Cream Cheese", image: "https://images.unsplash.com/photo-1551024506-0bccd828d307?w=400&h=300&fit=crop", cookTime: "8 min", difficulty: "Easy", calories: 290 }
  ],
  lunch: [
    { id: 11, name: "Mediterranean Quinoa Salad", image: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400&h=300&fit=crop", cookTime: "15 min", difficulty: "Easy", calories: 380 },
    { id: 12, name: "Grilled Chicken Caesar Wrap", image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=300&fit=crop", cookTime: "25 min", difficulty: "Medium", calories: 420 },
    { id: 13, name: "Thai Coconut Soup", image: "https://images.unsplash.com/photo-1569718212165-3a8278d5f624?w=400&h=300&fit=crop", cookTime: "30 min", difficulty: "Medium", calories: 340 },
    { id: 14, name: "Caprese Panini", image: "https://images.unsplash.com/photo-1539252554453-80ab65ce3586?w=400&h=300&fit=crop", cookTime: "12 min", difficulty: "Easy", calories: 350 },
    { id: 15, name: "Asian Fusion Bowl", image: "https://images.unsplash.com/photo-1512058564366-18510be2db19?w=400&h=300&fit=crop", cookTime: "20 min", difficulty: "Medium", calories: 390 },
    { id: 16, name: "Turkey Club Sandwich", image: "https://images.unsplash.com/photo-1553909489-cd47e0ef937f?w=400&h=300&fit=crop", cookTime: "10 min", difficulty: "Easy", calories: 480 },
    { id: 17, name: "Stuffed Bell Peppers", image: "https://images.unsplash.com/photo-1571997478779-2adcbbe9ab2f?w=400&h=300&fit=crop", cookTime: "45 min", difficulty: "Medium", calories: 320 },
    { id: 18, name: "Poke Bowl", image: "https://images.unsplash.com/photo-1546833999-b9f581a1996d?w=400&h=300&fit=crop", cookTime: "18 min", difficulty: "Easy", calories: 450 },
    { id: 19, name: "Chicken Tikka Salad", image: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=400&h=300&fit=crop", cookTime: "35 min", difficulty: "Hard", calories: 410 },
    { id: 20, name: "Loaded Sweet Potato", image: "https://images.unsplash.com/photo-1553621042-f6e147245754?w=400&h=300&fit=crop", cookTime: "40 min", difficulty: "Easy", calories: 360 }
  ],
  dinner: [
    { id: 21, name: "Herb-Crusted Salmon", image: "https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=400&h=300&fit=crop", cookTime: "25 min", difficulty: "Medium", calories: 520 },
    { id: 22, name: "Chicken Parmesan", image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=300&fit=crop", cookTime: "45 min", difficulty: "Medium", calories: 580 },
    { id: 23, name: "Beef Stir-Fry", image: "https://images.unsplash.com/photo-1603133872878-684f208fb84b?w=400&h=300&fit=crop", cookTime: "20 min", difficulty: "Easy", calories: 450 },
    { id: 24, name: "Mushroom Risotto", image: "https://images.unsplash.com/photo-1476124369491-e7addf5db4f6?w=400&h=300&fit=crop", cookTime: "35 min", difficulty: "Hard", calories: 480 },
    { id: 25, name: "Taco Tuesday Bowl", image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=300&fit=crop", cookTime: "30 min", difficulty: "Medium", calories: 420 },
    { id: 26, name: "Lemon Garlic Shrimp Pasta", image: "https://images.unsplash.com/photo-1621996346565-e3dbc353d2e5?w=400&h=300&fit=crop", cookTime: "22 min", difficulty: "Medium", calories: 510 },
    { id: 27, name: "BBQ Pulled Pork", image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop", cookTime: "180 min", difficulty: "Hard", calories: 650 },
    { id: 28, name: "Vegetarian Curry", image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=300&fit=crop", cookTime: "40 min", difficulty: "Medium", calories: 380 },
    { id: 29, name: "Grilled Steak with Veggies", image: "https://images.unsplash.com/photo-1544025162-d76694265947?w=400&h=300&fit=crop", cookTime: "25 min", difficulty: "Medium", calories: 620 },
    { id: 30, name: "Fish Tacos", image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ca4b?w=400&h=300&fit=crop", cookTime: "28 min", difficulty: "Easy", calories: 380 }
  ]
};

export const mockMealPlans = [
  {
    day: "Monday",
    breakfast: "Overnight Oats with Berries",
    lunch: "Grilled Chicken Salad",
    dinner: "Spaghetti with Marinara Sauce"
  },
  {
    day: "Tuesday",
    breakfast: "Greek Yogurt Parfait",
    lunch: "Turkey and Avocado Wrap",
    dinner: "Baked Salmon with Vegetables"
  },
  {
    day: "Wednesday",
    breakfast: "Scrambled Eggs and Toast",
    lunch: "Quinoa Buddha Bowl",
    dinner: "Chicken Stir-Fry with Rice"
  },
  {
    day: "Friday",
    breakfast: "Smoothie Bowl",
    lunch: "Mediterranean Wrap",
    dinner: "Beef Tacos with Black Beans"
  }
];

export const mockRecipes = [
  {
    id: 1,
    name: "Quick Chicken Stir-Fry",
    category: "Dinner",
    cookTime: "20 min",
    servings: "4 servings",
    rating: "4.5",
    difficulty: "Easy"
  },
  {
    id: 2,
    name: "Avocado Toast Supreme",
    category: "Breakfast",
    cookTime: "10 min",
    servings: "2 servings",
    rating: "4.8",
    difficulty: "Easy"
  },
  {
    id: 3,
    name: "Mediterranean Quinoa Salad",
    category: "Lunch",
    cookTime: "15 min",
    servings: "6 servings",
    rating: "4.6",
    difficulty: "Easy"
  },
  {
    id: 4,
    name: "Homemade Pizza Margherita",
    category: "Dinner",
    cookTime: "45 min",
    servings: "4 servings",
    rating: "4.7",
    difficulty: "Medium"
  },
  {
    id: 5,
    name: "Chocolate Chip Cookies",
    category: "Dessert",
    cookTime: "25 min",
    servings: "24 cookies",
    rating: "4.9",
    difficulty: "Easy"
  },
  {
    id: 6,
    name: "Protein Smoothie Bowl",
    category: "Breakfast",
    cookTime: "5 min",
    servings: "1 serving",
    rating: "4.4",
    difficulty: "Easy"
  },
  {
    id: 7,
    name: "Beef and Broccoli",
    category: "Dinner",
    cookTime: "30 min",
    servings: "4 servings",
    rating: "4.5",
    difficulty: "Medium"
  },
  {
    id: 8,
    name: "Caesar Salad",
    category: "Lunch",
    cookTime: "15 min",
    servings: "4 servings",
    rating: "4.3",
    difficulty: "Easy"
  }
];

export const mockDeals = [
  {
    id: 1,
    title: "Organic Produce Bundle",
    description: "Fresh organic fruits and vegetables",
    originalPrice: 24.99,
    salePrice: 14.99,
    discount: "40%",
    store: "Green Market",
    validUntil: "3 days",
    rating: "4.8"
  },
  {
    id: 2,
    title: "Premium Meat Selection",
    description: "Grass-fed beef and free-range chicken",
    originalPrice: 45.99,
    salePrice: 32.19,
    discount: "30%",
    store: "Fresh Foods",
    validUntil: "5 days",
    rating: "4.6"
  },
  {
    id: 3,
    title: "Dairy Essentials Pack",
    description: "Milk, cheese, yogurt, and eggs",
    originalPrice: 18.99,
    salePrice: 12.34,
    discount: "35%",
    store: "City Grocery",
    validUntil: "2 days",
    rating: "4.7"
  },
  {
    id: 4,
    title: "Pantry Staples Bundle",
    description: "Rice, pasta, canned goods, and spices",
    originalPrice: 29.99,
    salePrice: 14.99,
    discount: "50%",
    store: "Green Market",
    validUntil: "1 week",
    rating: "4.5"
  },
  {
    id: 5,
    title: "Breakfast Combo",
    description: "Cereals, oats, bread, and juice",
    originalPrice: 22.99,
    salePrice: 16.09,
    discount: "30%",
    store: "Corner Store",
    validUntil: "4 days",
    rating: "4.4"
  },
  {
    id: 6,
    title: "Snack Attack Bundle",
    description: "Nuts, crackers, chips, and dried fruits",
    originalPrice: 19.99,
    salePrice: 11.99,
    discount: "40%",
    store: "Fresh Foods",
    validUntil: "6 days",
    rating: "4.2"
  }
];

export const mockBudgetData = {
  monthlyBudget: 800,
  totalSpent: 542,
  categories: [
    { name: "Groceries", budgeted: 400, spent: 276 },
    { name: "Dining Out", budgeted: 200, spent: 156 },
    { name: "Snacks", budgeted: 100, spent: 67 },
    { name: "Beverages", budgeted: 100, spent: 43 }
  ],
  recentTransactions: [
    { id: 1, date: "2024-01-20", store: "Green Market", amount: 45.67, category: "Groceries" },
    { id: 2, date: "2024-01-19", store: "Corner Store", amount: 12.99, category: "Snacks" },
    { id: 3, date: "2024-01-18", store: "Fresh Foods", amount: 78.45, category: "Groceries" },
    { id: 4, date: "2024-01-17", store: "Green Market", amount: 23.56, category: "Beverages" }
  ]
};